module.exports = __webpack_public_path__ + "img/fan-flow-placeholder.2263b54a.svg";